import { Grid, Paper } from "@material-ui/core";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuItem, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { calculateSettlementTotals, formatAmount, SectionTitle, StyledTableCell, StyledTableRow } from "./SettlementDetailsShared";

const SettlementBreakdownSection = ({
  canUserActOnStatus,
  data,
  enableEdit,
  handleAddRow,
  handleDeleteRow,
  interimList,
  issuerYearList,
  setData,
  setUpdatedData,
  totalDividend,
  updatedData,
}) => (        <Grid item xs={12} md={6}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#4791e6ff", borderRadius: 8, marginBottom: 4 }}>
            <SectionTitle compact>Settlement Breakdown</SectionTitle>
            {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) && (
              <IconButton size="small" onClick={handleAddRow} style={{ color: "white", padding: "2px", marginRight: "4px" }}>
                <AddCircleIcon fontSize="small" />
              </IconButton>
            )}
          </div>
          <div
            style={{
              width: "100%",
              maxHeight: "300px",
              overflowY: "auto",
              overflowX: "auto",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#fafafa",
              scrollbarWidth: "none",
            }}
          >
            <TableContainer component={Paper} sx={{ boxShadow: 0,scrollbarWidth: "none", maxHeight: "300px"}}>
              <Table size="small" stickyHeader  sx={{scrollbarWidth: "none" }}>
                <TableHead sx={{ backgroundColor: "#eee", textAlign: "center" }}>
                  <StyledTableRow>
                    <StyledTableCell style={{ textAlign: "center" }}>SL No</StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>Year</StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>Year Type Dividend</StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>Dividend</StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>Suspense</StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>Total</StyledTableCell>
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) && (
                      <StyledTableCell style={{ textAlign: "center" }}>Action</StyledTableCell>
                    )}
                    {/* <StyledTableCell style={{ textAlign: "center" }}>Status</StyledTableCell> */}
                  </StyledTableRow>
                </TableHead>
                <TableBody >
                  {data.settelementDetails?.length ? (
                    data.settelementDetails.map((item, index) => (
                      <StyledTableRow key={item.id} >
                        <StyledTableCell style={{ textAlign: "center" }}>{index + 1}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          {/* {item.issuerYeaFormat.year} */}
                          {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                            <TextField
                              select
                              fullWidth
                              variant="standard"
                              size="small"
                              value={updatedData.settelementDetails[index]?.issuerYeaFormat?.id || ""}
                              onChange={(e) => {
                                const selectedYearObj = issuerYearList.find(y => String(y.id) === String(e.target.value));
                                const newDetails = [...updatedData.settelementDetails];
                                newDetails[index] = { 
                                  ...newDetails[index], 
                                  issuerYeaFormat: selectedYearObj || newDetails[index].issuerYeaFormat 
                                };
                                const totals = calculateSettlementTotals(newDetails);
                                setUpdatedData((prev) => ({
                                  ...prev,
                                  settelementDetails: newDetails,
                                  p_suspense_amount: totals.totalSuspenseAmount,
                                  p_totalamount: totals.totalAmount,
                                }));
                                
                                const newDataDetails = [...data.settelementDetails];
                                newDataDetails[index] = { 
                                  ...newDataDetails[index], 
                                  issuerYeaFormat: selectedYearObj || newDataDetails[index].issuerYeaFormat 
                                };
                                setData((prev) => ({ ...prev, settelementDetails: newDataDetails, ...totals }));
                              }}
                            >
                              {issuerYearList.map((option) => (
                                <MenuItem key={option.id} value={option.id} style={{ fontSize: 13, fontWeight: "bold" }}>
                                  {option.year}
                                </MenuItem>
                              ))}
                              {/* Fallback MenuItem if issuerYearList doesn't contain the currently selected year yet */}
                              {updatedData.settelementDetails[index]?.issuerYeaFormat?.id && 
                               !issuerYearList.find(y => String(y.id) === String(updatedData.settelementDetails[index].issuerYeaFormat.id)) && (
                                <MenuItem value={updatedData.settelementDetails[index].issuerYeaFormat.id} style={{ fontSize: 13, fontWeight: "bold" }}>
                                  {updatedData.settelementDetails[index].issuerYeaFormat.year}
                                </MenuItem>
                              )}
                            </TextField>
                          ) : (
                            item.issuerYeaFormat?.year || "N/A"
                          )}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          {/* {item.yearTypeDividend} */}
                          {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                            <TextField
                              select
                              fullWidth
                              variant="standard"
                              size="small"
                              value={updatedData.settelementDetails[index]?.yearTypeDividend || ""}
                              onChange={(e) => {
                                const val = e.target.value;
                                const newDetails = [...updatedData.settelementDetails];
                                newDetails[index] = { ...newDetails[index], yearTypeDividend: val };
                                const totals = calculateSettlementTotals(newDetails);
                                setUpdatedData((prev) => ({
                                  ...prev,
                                  settelementDetails: newDetails,
                                  p_suspense_amount: totals.totalSuspenseAmount,
                                  p_totalamount: totals.totalAmount,
                                }));
                                
                                const newDataDetails = [...data.settelementDetails];
                                newDataDetails[index] = { ...newDataDetails[index], yearTypeDividend: val };
                                setData((prev) => ({ ...prev, settelementDetails: newDataDetails, ...totals }));
                              }}
                            >
                              {interimList.map((option, idx) => (
                                <MenuItem key={idx} value={option.name} style={{ fontSize: 13, fontWeight: "bold" }}>
                                  {option.description + ' (' + option.name + ') '}
                                </MenuItem>
                              ))}
                              {/* Fallback MenuItem if interimList doesn't contain the current value yet */}
                              {updatedData.settelementDetails[index]?.yearTypeDividend && 
                               !interimList.find(y => String(y.name) === String(updatedData.settelementDetails[index].yearTypeDividend)) && (
                                <MenuItem value={updatedData.settelementDetails[index].yearTypeDividend} style={{ fontSize: 13, fontWeight: "bold" }}>
                                  {updatedData.settelementDetails[index].yearTypeDividend}
                                </MenuItem>
                              )}
                            </TextField>
                          ) : (
                            item.yearTypeDividend || "N/A"
                          )}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          {/* {formatAmount(Number(item.amount)-Number(item.suspenseAmount))} */}
                          {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                            <TextField
                              size="small"
                              type="text"
                              variant="standard"
                              value={updatedData.settelementDetails[index]?.dividendInput ?? ""}
                              onChange={(event) => {
                                let val = event.target.value;
                                if (!/^\d*\.?\d*$/.test(val)) return;
                                if (val.startsWith("0") && val.length > 1 && !val.startsWith("0.")) {
                                  val = val.replace(/^0+/, "");
                                }
                                if (val.startsWith(".")) val = "0" + val;

                                const newDividend = Number(val) || 0;
                                const suspense = Number(updatedData.settelementDetails[index]?.suspenseInput) || 0;
                                const newTotal = newDividend + suspense;
                                
                                const newDetails = [...updatedData.settelementDetails];
                                newDetails[index] = { ...newDetails[index], dividendInput: val, amount: newTotal };
                                const totals = calculateSettlementTotals(newDetails);
                                setUpdatedData((prev) => ({
                                  ...prev,
                                  settelementDetails: newDetails,
                                  p_suspense_amount: totals.totalSuspenseAmount,
                                  p_totalamount: totals.totalAmount,
                                }));
                                
                                const newDataDetails = [...data.settelementDetails];
                                newDataDetails[index] = { ...newDataDetails[index], amount: newTotal };
                                setData((prev) => ({
                                  ...prev,
                                  settelementDetails: newDataDetails,
                                  ...totals,
                                }));
                              }}
                            />
                          ) : (
                            formatAmount(Number(item.amount) - Number(item.suspenseAmount))
                          )}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          {/* {formatAmount(item.suspenseAmount)} */}
                          {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                            <TextField
                              size="small"
                              type="text"
                              variant="standard"
                              value={updatedData.settelementDetails[index]?.suspenseInput ?? ""}
                              onChange={(event) => {
                                let val = event.target.value;
                                if (!/^\d*\.?\d*$/.test(val)) return;
                                if (val.startsWith("0") && val.length > 1 && !val.startsWith("0.")) {
                                  val = val.replace(/^0+/, "");
                                }
                                if (val.startsWith(".")) val = "0" + val;

                                const newSuspense = Number(val) || 0;
                                const currentDividend = Number(updatedData.settelementDetails[index]?.dividendInput) || 0;
                                const newTotal = currentDividend + newSuspense;
                                
                                const newDetails = [...updatedData.settelementDetails];
                                newDetails[index] = { ...newDetails[index], suspenseInput: val, suspenseAmount: newSuspense, amount: newTotal };
                                const totals = calculateSettlementTotals(newDetails);
                                setUpdatedData((prev) => ({
                                  ...prev,
                                  settelementDetails: newDetails,
                                  p_suspense_amount: totals.totalSuspenseAmount,
                                  p_totalamount: totals.totalAmount,
                                }));
                                
                                const newDataDetails = [...data.settelementDetails];
                                newDataDetails[index] = { ...newDataDetails[index], suspenseAmount: newSuspense, amount: newTotal };
                                setData((prev) => ({
                                  ...prev,
                                  settelementDetails: newDataDetails,
                                  ...totals,
                                }));
                              }}
                            />
                          ) : (
                            formatAmount(item.suspenseAmount)
                          )}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>{formatAmount(item.amount)}</StyledTableCell>
                        {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) && (
                          <StyledTableCell style={{ textAlign: "center" }}>
                            <IconButton disabled = {data.settelementDetails.length <= 1} onClick={() => handleDeleteRow(index)} color="error" size="small">
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </StyledTableCell>
                        )}
                        {/* <StyledTableCell style={{ textAlign: "center" }}>
                          {item.status === 1 ? "Active" : "Inactive"}
                        </StyledTableCell> */}
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={5} align="center">
                        No settlement details found
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                  
                </TableBody>
                <StyledTableRow sx={{
                                position: "sticky",
                                bottom: 0,
                               backgroundColor: "#ffffff !important",
                                // zIndex: 2, // Ensures it stays above the content
                              }}>
                      <StyledTableCell colSpan={3} align="center">
                        <strong>Total</strong>
                      </StyledTableCell>
                      <StyledTableCell  align="center">
                        <strong>{formatAmount(totalDividend)}</strong>
                      </StyledTableCell>
                      <StyledTableCell  align="center">
                        <strong>{formatAmount(data.totalSuspenseAmount)}</strong>
                      </StyledTableCell>
                      <StyledTableCell  align="center">
                        <strong>{formatAmount(data.totalAmount)}</strong>
                      </StyledTableCell>
                    </StyledTableRow>
              </Table>
            </TableContainer>
          </div>
        </Grid>);

export default SettlementBreakdownSection;
